import React, {useEffect, useState} from 'react';
import {AccordionDetails} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {AccordionData} from "../../interfaces/AccordionData";
import SingleInput from "./SingleInput";


interface IProps {
    data: AccordionData[],
    setData: React.Dispatch<React.SetStateAction<AccordionData[]>>
}

export default function AccordionDetailsInput({data, setData}: IProps) {
    const [formState, setFormState] = useState<AccordionData[]>([] as AccordionData[]);

    useEffect(() => setFormState(data), [data])

    const handleInputChange = (index: number, newValue: string) => {
        const newData = [...data];
        newData[index].value = newValue;
        setData(newData);
    };

    return (
        <AccordionDetails>
            <Grid container spacing={1}>
                {data.map((field, index) => {
                    return <SingleInput field={field} index={index} handleInputChange={handleInputChange}/>
                })}
            </Grid>
        </AccordionDetails>
    );
}